<template>
  <v-row class="d-flex justify-center ma-0 pa-0">
    <!-- 學程大圖 -->  
    <v-col cols="12" class="pa-0 ma-0">
      <home-slider />
    </v-col>
    <!-- <v-col cols="12" class="pa-0 ma-0">
      <v-row class="pa-0 ma-0 po-r">
        <v-col
          cols="12"
          :style="{
            backgroundImage: `url(tools/img_2/banner/web01.jpg)`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundBlendMode: 'multiply',
            backgroundColor: '#00000010',
          }"
          class="homebanner d-flex justify-center align-center ma-0 w-100 h-100 po-r"
        >
          <v-row
            class="pa-0 ma-0 ml-5 d-flex justify-center align-center z-1"
          >
            <v-col cols="12" md="10" xl="8" class="pa-0 ma-0 bannerText">
              <v-col cols="12" class="py-0 font-B">
                <h2 class="w-fit banner_title banner-font-h3">
                  {{ t("大葉大學半導體學士學位學程") }}
                </h2>
                <div class="w-100 banner_engtitle banner-font-h3">
                  {{ t("Bachelor’s Program of semiconductor, DYU") }}
                </div>
                <div class="w-100 banner_engtitle banner-font-h5">
                  {{
                    t(
                      "大葉大學深耕彰化高教培育高科技人才，帶領學生深入探索半導體產業。",
                    )
                  }}
                </div>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col> -->

    <!-- sec1 學程特色 -->
    <v-row
      class="ma-0 d-flex justify-center align-center white-bg po-r"
      :class="{'pa-0': isMobile, 'pa-10': !isMobile}"
    >
      <!-- 左边栏 -->
      <v-col cols="12" md="6" class="pa-10 features-container">
        <h2 class="banner_title banner-font-h3" style="color: #3498db">
          學程特色
        </h2>
        <div class="features">
          <v-card class="feature-card" flat>
            <v-card-text class="custom-card-text" data-index="01">
              中部唯一招收學士班之普通大學專業培育半導體人才
            </v-card-text>
          </v-card>
          <v-card class="feature-card" flat>
            <v-card-text class="custom-card-text" data-index="02">
              學生專題結合產業需求，業界支援業師授課，畢業即就業
            </v-card-text>
          </v-card>
          <v-card class="feature-card" flat>
            <v-card-text class="custom-card-text" data-index="03">
              結合電機、機械、資訊、材料、環境安全工程之專業師資
            </v-card-text>
          </v-card>
          <v-card class="feature-card" flat>
            <v-card-text class="custom-card-text" data-index="04">
              導入半導體實務製程、AI人工智慧、永續議題，符合全球產業趨勢
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <!-- 右边栏 -->
      <v-col
        cols="12"
        md="5"
        class="pa-10 d-flex justify-center align-center"
      >
        <div class="image-container">
          <img
            src="tools/img_2/2.jpg"
            alt="半導體示意圖"
            class="parallelogram-image"
          />
        </div>
      </v-col>
      <div class="corner-shape graph-sec1-left"></div>
      <div class="corner-shape graph-sec1-right"></div>
    </v-row>

    <!-- sec2 場域空間 -->
    <v-row class="ma-0 d-flex justify-center align-center gray-bg po-r"
              :class="{'p-0': isMobile, 'pa-10': !isMobile}">
      <v-col cols="12" md="11" class="pa-10">
        <h2
          class="text-left banner_title banner-font-h3"
          style="color: #3498db"
        >
          場域空間
        </h2>
        <h5 class="text-left" style="color: #949494">
          模擬實際工作環境的實驗空間
        </h5>
        <v-row class="mt-5" align="start" justify="center">
          <v-col
            v-for="card in filteredCards"
            :key="card.id"
            cols="12"
            md="4"
            class="d-flex justify-center mb-4"
          >
            <v-row
              class="row pa-0 ma-0 mx-auto labcard"
              :class="isMobile ? '' : ''"
            >
              <v-col
                cols="12"
                class="pb-0 card-img"
                :class="isMobile ? '' : ''"
              >
                <v-img
                  class="rounded card-image-hover"
                  :src="card.image"
                  width="100%"
                  :aspect-ratio="16 / 9"
                ></v-img>
              </v-col>
              <v-col
                cols="12"
                class="pt-3 pa-4 pb-3"
                :class="isMobile ? '' : ''"
              >
                <p class="banner-font-h5 font-B mb-1 gray-bgc">
                  {{ t(card.name) }}
                </p>
                <!-- <div class="mt-2 banner-font-h6 color-black">
                  {{ t(card.description) }}
                </div> -->
              </v-col>
            </v-row>
          </v-col>
          <div class="graph-sec2-right"></div>
        </v-row>
        <v-col cols="12" class="d-flex justify-end align-center">
          <a
            class="ma-2 color-btn font-B rounded-pill icon16"
            href="/room"
            title="了解更多">{{ t('more') }}
            <i class="ml-2 fa-solid fa-angles-right"></i>
          </a>
        </v-col>
      </v-col>
    </v-row>

    <!-- sec3 就業趨勢 -->
    <v-row
      class="ma-0 d-flex justify-center align-center white-bg po-r"
      :class="{'pa-0': isMobile, 'pa-10': !isMobile}"
    >
      <!-- 左边栏 -->
      <v-col
        cols="12"
        md="5"
        class="pa-10 d-flex justify-center align-center"
      >
        <div class="image-container">
          <img
            src="tools/img_2/banner/04.jpg"
            alt="Your Image"
            class="parallelogram-image"
          />
        </div>
      </v-col>
      <!-- 右边栏 -->
      <v-col cols="12" md="7" class="pa-10 features-container">
        <h2 class="banner_title banner-font-h3" style="color: #3498db">
          AI科技新時代，
        </h2>
        <h2 class="banner_title banner-font-h3" style="color: #3498db">
          半導體人才需求倍增。
        </h2>
        <v-row class="circles mt-5">
          <v-col cols="12" sm="4" class="d-flex justify-center">
            <v-card class="circle-card" flat>
              <v-card-text class="circle-card-text banner-font-h6">
                彰化中科二林精密園區封測大廠矽品、半導體大廠合晶進駐
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex justify-center">
            <v-card class="circle-card" flat>
              <v-card-text class="circle-card-text banner-font-h6">
                台中科學園區台積電擴建
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex justify-center">
            <v-card class="circle-card" flat>
              <v-card-text class="circle-card-text banner-font-h6">
                半導體人才缺口大，平均可獲得2.3份工作
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <div class="graph-sec3-left"></div>
    </v-row>

    <!-- sec4 未來職業 -->
    <v-row
      class="pa-10 ma-0 d-flex justify-center align-center darkgray-bg po-r"
    >
      <v-col cols="12" md="8" class="pa-10 features-container">
        <h2
          class="banner_title banner-font-h3 text-center"
          style="color: #3498db"
        >
          未來可選擇的職業類別
        </h2>
        <v-row class="mt-5">
          <v-col
            cols="6"
            sm="4"
            class="d-flex justify-center"
            v-for="occupation in occupations"
            :key="occupation.job"
          >
            <div class="icon-text-wrapper">
              <i class="fa-solid fa-briefcase"></i>
              <span>{{ occupation.job }}</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- sec5 高中體驗 -->
    <v-row
      class="ma-0 d-flex justify-center align-center white-bg po-r"
                :class="{'pa-0': isMobile, 'pa-10': !isMobile}"
    >
      <!-- 左边栏 -->
      <v-col cols="12" md="6" class="pa-10 features-container">
        <h2
          class="text-left banner_title banner-font-h3"
          style="color: #3498db"
        >
          開放高中預約體驗
        </h2>
        <h5 class="text-left mt-5" style="color: #949494">
          大葉大學將半導體教學能量擴散，依據教育部半導體補助課程六大方向設計教案，提供高中職學生學習渠道。
        </h5>
        <div class="experience-container mt-5">
          <v-card class="experience-card" flat>
            <v-card-text class="experience-content banner-font-h5">
              半導體原理
            </v-card-text>
          </v-card>
          <v-card class="experience-card" flat>
            <v-card-text class="experience-content banner-font-h5">
              半導體製程
            </v-card-text>
          </v-card>
          <v-card class="experience-card" flat>
            <v-card-text class="experience-content banner-font-h5">
              半導體應用
            </v-card-text>
          </v-card>
          <v-card class="experience-card" flat>
            <v-card-text class="experience-content banner-font-h5">
              電路設計
            </v-card-text>
          </v-card>
          <v-card class="experience-card" flat>
            <v-card-text class="experience-content banner-font-h5">
              電的科學知識
            </v-card-text>
          </v-card>
          <v-card class="experience-card" flat>
            <v-card-text class="experience-content banner-font-h5">
              社會面向
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <!-- 右边栏 -->
      <v-col
        cols="12"
        md="5"
        class="px-10 d-flex justify-center align-center"
      >
        <div class="image-container">
          <img
            src="tools/img_2/banner/06.jpg"
            alt="半導體示意圖"
            class="parallelogram-image"
          />
        </div>
      </v-col>
      <div class="corner-shape graph-sec5-right"></div>
    </v-row>

    <!-- sec6 news -->
    <v-col cols="12" md="10" xl="8" class="mt-10 po-r">
      <div
        v-if="fbdata.facebookActive == null || fbdata.facebookActive == false "
      >
          <newsMessage
            title-name="最新消息"
            piece="8"
            class="pa-0 ma-0"
            :news="message"
            :moreurl="{ name: '最新消息', url: '/newsMessageAll' }"
            :previousPageUrl="'Home'"
          />
        <div class="corner-shape graph-sec6-left"></div>
        <div class="corner-shape graph-sec6-right"></div>
      </div>
    </v-col>

    <!-- sec7 media -->
    <v-row
      class="pa-10 ma-0 d-flex justify-center align-center po-r darkgray-bg">
      <v-col cols="12" md="10" class="mt-10 po-r">      
        <v-row no-gutters>  
          <v-col cols="12" class="d-flex justify-center">
            <h2
              class="banner_title banner-font-h3 text-center"
              style="color: #050F28"
            >
              媒體報導
            </h2>
          </v-col>
        </v-row>
        <v-row
          justify-lg="space-between"
          justify="center"
          align="stretch"
          class="mt-5"
          v-if="mediaIsActive">
          <v-col cols="12" md="4"
              v-for="(mediaItem, index) in mediaData.news"
              :key="index"
            >
            <media-card  
              class="mt-lg-0"
              :mediaData="mediaItem"
              :title="'媒體報導'"
              :poolID="mediaData.pool_ID"
              :pathPage="'/mediaContent'"
            ></media-card>
          </v-col>

        </v-row>
      </v-col>
    </v-row>  
  </v-row>
</template>
<script>
import axios from "axios";
import homeSlider from "../components/homeSlider";
import { mapState, mapMutations } from "vuex";
// import Banner from "../components/banner.vue";
import mediaCard from "../components/mediaCard.vue";
import newsMessage from "../components/newsMessage.vue";
import allcent from "@/components/allComponent.vue";

export default {
  name: "Home",

  components: {
    newsMessage,
    mediaCard, 
    // Banner,
    homeSlider,
    allcent,
  },

  data: () => ({
    message: "", //最新消息
    mediaData: {},
    
    fbdata: {}, //??
    testMode: 0, //??
    cards: [],
    occupations: [],
    // banner: null,
    show: true,

    //內容使用
    data_1: null,
    data_1_titleStyle: "font-h2 color-bg-title rounded-pill px-8 px-md-14",
    data_1_secondStyle: "font-h3ti color-title",

    data_2: null,
    data_2_titleStyle: "font-h2 color-title",
    data_2_secondStyle: "font-h3 color-subtitle",
  }),
  created() {
    this.$store.commit("scrollToTop");
  },
  mounted() {
    this.getData();
    this.getnewsMessage();
    this.getMediaNews();

    //抓頁籤名稱
    document.getElementById("pageTitle").innerHTML = this.$store.state.deptName;
    if (this.$store.state.lang == "en") {
      if (location.href.indexOf("#reloaded") == -1) {
        location.href = location.href + "#reloaded";
        location.reload();
      }
    }
    if (
      location.href.indexOf("local") != -1 ||
      location.href.indexOf("8080") != -1 ||
      location.href.indexOf("wm") != -1
    )
      this.testMode = true;
    else this.testMode = false;

    // 讀取實驗室空間的json
    axios
      .get("tools/json/lab.json")
      .then((response) => {
        this.cards = response.data;
      })
      .catch((error) => {
        console.error("Error fetching card data:", error);
      });

    // 讀取職業的json
    axios
      .get("tools/json/occupation.json")
      .then((response) => {
        this.occupations = response.data.occupations;
        console.log("读取 JSON 的职业数据:", this.occupations);
      })
      .catch((error) => {
        console.error("Error fetching occupation data:", error);
      });
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown; // 当屏幕宽度小于 "md" 断点时返回 true
    },
    ...mapState([
      "poolId",
      "colorAll",
      "mediaPoolID",
      "activityPoolID",
      "siteSettingSuccess",
      "mediaIsActive",
      "activityIsActive",
      "facebookActive",
      "facebook",
    ]),

    //篩選實驗室空間僅顯示home為true的值
    filteredCards() {
      return this.cards.filter((card) => card.home);
    },
  },

  watch: {
    siteSettingSuccess: function () {
      this.getnewsMessage();
      // this.getMarquee();
      // this.getFastLink();
      this.getMediaNews();
    },
  },

  methods: {
    //處裡取得的 index 資料
    getData() {
      axios
        .get("/tools/json/index.json")
        .then((response) => {
          // 成功處理回應數據
          this.banner = response.data[0];
          this.data_1 = response.data[1];
          if (response.data[2].content) this.data_2 = response.data[2];
        })
        .catch((error) => {
          // 處理錯誤
          console.error("資料獲取失敗", error);
        });
    },

    //取得最新消息 url: "tools/json/newsMessage.json",
    getnewsMessage() {
      var self = this;
      if (location.hostname == "localhost") {
        axios({
          method: "post",
          baseURL: "",
          url: "https://tis.dyu.edu.tw/app/app/news.php",
          "Content-Type": "application/json",
          data: {
            pool_ID: self.poolId,
            edate: "undefined",
            eitems: 15,
            sdate: "undefined",
            sitems: 0,
          },
        })
          .then((result) => {
            self.message = result.data;
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        axios({
          method: "post",
          baseURL: "",
          url: "https://tis.dyu.edu.tw/app/app/news.php",
          "Content-Type": "application/json",
          data: {
            pool_ID: self.poolId,
            edate: "undefined",
            eitems: 15,
            sdate: "undefined",
            sitems: 0,
          },
        })
          .then((result) => {
            self.message = result.data;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },

    getMediaNews: function() {
      if (!this.mediaPoolID) {
        console.error("mediaPoolID is not defined or invalid");
        return;
      }

      axios
        .post("https://tis.dyu.edu.tw/app/app/news.php", {
          pool_ID: this.mediaPoolID,
          sitems: 0,
          eitems: 3,
        })
        .then((response) => {
          this.setMediaNews(response.data);
        })
        .catch((error) => {
          console.error("Error fetching media news:", error);
        });
    },
    
    // setMediaNews: function(data) {
    //   this.mediaData = data;
    //   console.log(this.mediaData)
    // },

    setMediaNews: function(data) {
      this.mediaData = data;
      console.log("Media Data:", this.mediaData);
    },

    //接收fbdata
    setFB: function (data) {
      this.fbdata = data;
    },

    // //marquee
    // getMarquee: async function() {
    //   const self = this;
    //   var url = "";
    //   var dateNow = new Date();

    //   //make url
    //   if (self.$store.state.isDemo) {
    //     url = "tools/json/marquee_tw.json";
    //   } else {
    //     url = "marquee/marquee_tw.json";
    //   }
    //   axios.get(url).then(result => {
    //     var tmp = result.data;
    //     tmp.sort(function(a, b) {
    //       if (a.date_stop > b.date_stop) return 1;
    //       else if (a.date_stop == b.date_stop) {
    //         if (a.date_start > b.date_start) return 1;
    //         else return -1;
    //       } else return -1;
    //     });
    //     // remove over date
    //     tmp.reduceRight(function(preItem, item, index, ary) {
    //       var dateStop = new Date(item.date_stop);
    //       var dateStart = new Date(item.date_start);
    //       if (dateNow > dateStop || dateNow < dateStart) ary.splice(index, 1);
    //     }, []);
    //     tmp.forEach(
    //       element => (self.marquee.text += " " + element.marquee_desc)
    //     );
    //   });
    // },
    getFastLink: async function () {
      const self = this;
      var dateNow = new Date();
      var url = [];
      url.push(
        "https://icloud.dyu.edu.tw/link_common/read_json.php?poolid=" +
          self.$store.state.fastLinkPoolId,
      );
      url.push("https://icloud.dyu.edu.tw/link_common/read_json.php?poolid=1");
      Promise.all(url.map((item) => axios.get(item))).then((result) => {
        result.forEach((item) => {
          if (item.data) {
            item.data.reduceRight((preItem, link, index, ary) => {
              var dateStop = new Date(link.enddate);
              var dateStart = new Date(item.startdate);
              if (dateNow > dateStop || dateNow < dateStart)
                ary.splice(index, 1);
              else self.fastLink.push(link);
            });
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.gradient {
  background-color: var(--get-color-primary-l);
}
.home_up_BG-img {
  // height: 8vh;
  background-image: url(../../public/tools/img/doNotTouch/indexBg_standard_up.svg);
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain; //依照內容最大化填滿框架，並不超出範圍
}
.home_bottom_BG-img {
  // height: 8vh;
  background-image: url(../../public/tools/img/doNotTouch/indexBg_standard_up2.svg);
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain; //依照內容最大化填滿框架，並不超出範圍
}

.homebanner {
  height: 85vh;
  min-height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bannerText {
  position: relative;
}

.bannerText::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px; /* Adjust the width of the line */
  height: 100%; /* Adjust the height if needed */
  background-color: #174b94; /* Change the color as needed */
}

.banner_title {
  margin-bottom: 0;
  color: #fff;
}

.banner_engtitle {
  margin-top: 0;
  white-space: normal;
  color: #fff;
}

.banner-font-h1 {
  font-size: 3.5em;
}

.banner-font-h2 {
  font-size: 2em;
}

.banner-font-h3 {
  font-size: 1.8em;
}

.banner-font-h4 {
  font-size: 1.5em;
}

.banner-font-h5 {
  font-size: 1.2em;
}

.banner-font-h6 {
  font-size: 1em;
}

.white-bg {
  background-color: #fff;
}

.gray-bg {
  background-color: #fbfbfc;
  z-index: 1;
}
.darkgray-bg {
  background-color: #ededef;
  z-index: 3;
}

.features-container {
  z-index: 2;
}

.features {
  display: flex;
  flex-direction: column;
}

.v-card.feature-card {
  border: 2px solid #3498db;
  background-color: #fff;
  text-align: center;
  margin: 10px;
  text-align: left;
  display: flex;
  align-items: center;
  position: relative;
  padding: 5px;
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease; /* 添加过渡效果 */
  border-radius: 20px;
}

.custom-card-text {
  padding-left: 80px;
  font-size: 1em;
  color: #3498db;
  font-weight: bold;
  transition: color 0.3s ease; /* 添加过渡效果 */
}

.custom-card-text::before {
  content: attr(data-index);
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
  color: #3498db;
  font-size: 1.8em;

  width: 60px; /* 增加偽元素的寬度來匹配新的間距 */
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition:
    color 0.3s ease,
    transform 0.3s ease; /* 添加过渡效果 */
}

.v-card.feature-card:hover {
  background-color: #f0f8ff;
  border-color: #3498db;
}

.custom-card-text:hover {
  color: #3498db;
}

.custom-card-text::before:hover {
  color: #2c3e50;
  transform: translateY(-50%) scale(1.2);
}

.parallelogram-image {
  width: 100%;
  height: auto;
  clip-path: polygon(20% 0%, 100% 0%, 80% 100%, 0% 100%);
  position: relative;
  z-index: 5;
}
.image-container {
  position: relative;
  width: fit-content;
  height: fit-content;
}

.image-container::after {
  content: "";
  position: absolute;
  bottom: -20px;
  left: -30px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  clip-path: polygon(20% 0%, 100% 0%, 80% 100%, 0% 100%);
  z-index: 4;
}

.corner-shape {
  position: absolute;
  width: 50%;
  height: 120%;
  transform: skew(-20deg);
}

.labcard {
  background-color: transparent !important;
  width: 100%;
  overflow: hidden;
  box-shadow: none;
  border-radius: 0;
}

.gray-bgc {
  background-color: rgba(128, 128, 128, 0.8);
  color: white;
  padding: 5px 20px;
  border-radius: 20px;
  margin-bottom: 10px;
  display: flex-start;
  text-align: center;
}

.card-img {
  overflow: hidden;
}

.card-image-hover {
  transition: transform 0.3s ease-in-out; /* 設置圖片的過渡效果 */
}

.card-hover {
  .v-image__image {
    transition: all 0.7s ease-out;
    transform: scale(1);
  }
}

.card-image-hover:hover {
  transform: scale(1.1); /* 當鼠標懸停時圖片放大效果 */
}

.card-subtitle {
  color: #666; /* 副標題文字顏色 */
  font-size: 1rem;
  margin-top: 10; /* 確保副標題與標題之間沒有額外空隙 */
  height: auto;
}

.v-card.circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.v-card.circle-card {
  border-radius: 50%;
  border: solid 1px #949494;
  width: 100%;
  height: 0;
  padding-top: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #e5e5e5;
  color: #fff; /* Text color */
  transition: transform 0.3s ease; /* 平滑過渡效果 */
  position: relative;
  overflow: hidden;
}


.circle-card-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 10px;
  width: 90%;
  box-sizing: border-box;
}
@media screen and (max-width: 768px) {
  .v-card.circle-card {
    border-radius: 10px; /* 取消圓形，改為方形 */
    border: 2px solid #949494;
    background-color: #e5e5e5;
    width: 100%; /* 讓卡片寬度自動適應容器 */
    height: auto; /* 讓高度自動撐滿內容 */
    min-height: 10px; /* 設定最小高度，防止內容太少時過於扁平 */
    padding: 16px; /* 添加內邊距 */
    display: flex;
    flex-direction: column; /* 內容上下排列 */
    justify-content: center; /* 垂直居中 */
    align-items: center; /* 水平居中 */
    text-align: center;
    word-wrap: break-word; /* 自動換行 */
    white-space: normal;
    transition: background-color 0.3s ease; 
  }


  /* 文字樣式 */
  .circle-card-text {
    position: static; /* 移除絕對定位，讓文字正常流動 */
    transform: none; /* 取消變換效果 */
    padding: 10px;
    width: 100%; /* 讓文字內容佔滿卡片寬度 */
    box-sizing: border-box;
    text-align: center; /* 文字居中 */
    font-size: 1em;
    color: #3498db; /* 初始文字顏色 */
    font-weight: bold;
    word-wrap: break-word; /* 讓長詞換行 */
    white-space: normal; /* 允許文字自動換行 */
    height: auto; /* 讓高度自動根據內容增長 */
  }

}

.icon-text-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.icon-text-wrapper:hover {
  color: gray;
}

.icon-text-wrapper i {
  margin-right: 10px;
}

.icon-text-wrapper span {
  font-size: 16px;
}

.experience-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.v-card.experience-card {
  width: 45%;
  border: 2px solid #3498db;
  background-color: #fff;
  text-align: center;
  margin: 5px;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 30px;
}

.experience-content {
  padding: 16px; /* Adjust padding as needed */
  color: #3498db;
  font-weight: bold;
  text-align: center;
}

.graph-sec1-left,
.graph-sec1-right,
.graph-sec2-right,
.graph-sec3-left,
.graph-sec5-right,
.graph-sec6-left,
.graph-sec6-right{
  display: none;
}


@media screen and (min-width: 992px) {
  .graph-sec1-left {
    display: block;
    top: 0%;
    left: 0;
    transform: translateX(-75%) skew(-20deg);
    z-index: 0;
    background-color: #e5e5e5;
  }

  .graph-sec1-right,
  .graph-sec5-right {
    display: block;
    top: 0%;
    right: 0;
    transform: translateX(50%) skew(-20deg);
    z-index: 3;
    background-color: #174b94;
  }

  .graph-sec2-right {
    display: block;
    position: absolute;
    width: 75%;
    height: 100%;
    top: 0%;
    right: 0;
    z-index: -1;
    background-color: #e5e5e5;
    transform: translateX(25%) skew(-20deg);
  }

  .graph-sec3-left {
    display: block;
    position: absolute;
    top: -10%;
    left: -30%;
    width: 50%;
    height: 120%;
    transform: skew(-20deg);
    background-color: #174b94;
    z-index: 3;
  }

  .graph-sec6-left {
    display: block;
    top: 0%;
    left: 0;
    transform: translateX(-120%) skew(-20deg);
    z-index: 0;
    background-color: #174b94;
  }

  .graph-sec6-right {
    display: block;
    top: 0%;
    right: 0;
    transform: translateX(120%) skew(-20deg);
    z-index: 0;
    background-color: #e5e5e5;
  }

}
</style>